import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PublicConfigStore } from './public-config.store';

export const PUBLIC_CONFIG_LOADER = (store: PublicConfigStore, http: HttpClient) => () => {
    return http.get('/api/config')
        .pipe(map(data => {
            store.setData(data);
        }))
        .toPromise();
};
